import { SagaIterator } from 'redux-saga'
import { put, takeLatest, select, all, PutEffect } from 'redux-saga/effects'
import moment from 'moment-timezone'

import { getContentId } from '@tabeeb/modules/shared/content/selectors'
import { CreateFormAnswerRequest } from '@tabeeb/contracts/main-api/swagger-main-api'
import { getCurrentVideoTimestamp } from '@tabeeb/modules/player/selectors'

import * as rawActions from '../actions'
import { getCurrentForm, getSelectedGalleryItemId } from '../selectors'
import { calculateValue } from '../services/calculateDefaultValueOrCounterLimit'

function* setInitialValues(): SagaIterator {
  const currentForm: ReturnType<typeof getCurrentForm> = yield select(getCurrentForm)
  const currentPageId: ReturnType<typeof getSelectedGalleryItemId> = yield select(getSelectedGalleryItemId)
  const contentId: ReturnType<typeof getContentId> = yield select(getContentId)
  const timestamp: ReturnType<typeof getCurrentVideoTimestamp> = yield select(getCurrentVideoTimestamp)

  const { ReattachedNumberOfTimes, ContentFormId, selectedTabs, Controls, answers } = currentForm

  const tabsIds = selectedTabs || []
  const actions: PutEffect[] = []

  for (const control of Controls || []) {
    const hasAnswer = answers?.some((answer) => answer.FormControlId === control.Id)

    if (Boolean(control.InitialValue) && !hasAnswer) {
      let answerValue
      const { InitialValue, IncrementValue, IncrementPeriod } = control

      if (ReattachedNumberOfTimes && IncrementValue && IncrementPeriod !== null) {
        answerValue = calculateValue(InitialValue, IncrementValue, IncrementPeriod, ReattachedNumberOfTimes)
      } else answerValue = InitialValue

      let answerInfo: CreateFormAnswerRequest = {
        ContentId: contentId,
        ContentFormId: ContentFormId!,
        FormControlId: control.Id,
        PageId: currentPageId,
        Timestamp: timestamp,
        TimeZone: moment.tz.guess(),
      }

      if (answerValue) {
        answerInfo = { ...answerInfo, Value: `${answerValue}` }
      }

      if (tabsIds.length > 0) {
        answerInfo = { ...answerInfo, FormTabsIds: tabsIds }
      }

      actions.push(put(rawActions.sendFormAnswer.request(answerInfo)))
    }
  }

  yield all(actions)
}

function* initialValues() {
  yield all([takeLatest(rawActions.setInitialValues, setInitialValues)])
}

export default initialValues
